package navigation.settings.tags.addedittag

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.tag.domain.repository.TagRepository
import com.essntl.features.tag.ui.addedittag.AddEditTagEvent
import com.essntl.features.tag.ui.addedittag.AddEditTagState
import com.essntl.features.tag.ui.addedittag.AddEditTagValidation
import com.essntl.features.tag.ui.addedittag.AddEditTagViewModel
import com.essntl.toastmanager.ToastManager

class AddEditTagScreenModel(
    tagRepository: TagRepository,
    toastManager: ToastManager,
    loadingManager: LoadingManager,
) : StateScreenModel<AddEditTagState>(AddEditTagState()) {

    val validation = AddEditTagValidation()

    private val viewModel =
        AddEditTagViewModel(
            tagRepository = tagRepository,
            loadingManager = loadingManager,
            toastManager = toastManager,
            state = mutableState,
            scope = screenModelScope,
        )

    fun onEvent(event: AddEditTagEvent) = viewModel.onEvent(event)
}